// @flow
import { connect } from 'react-redux';
import AppleWatch from '../components/AppleWatch';

import type { RootState } from "../../../index";

function mapStateToProps(state: RootState) {
  return {
    locale: state.locale,
    localValues: state.localValues,
  };
}

export default connect(mapStateToProps)(AppleWatch);



// WEBPACK FOOTER //
// ./src/modules/custom-products/AppleWatch/container/AppleWatchContainer.js